import { render, staticRenderFns } from "./OrderShippingNew.vue?vue&type=template&id=32a7f86c&scoped=true&"
import script from "./OrderShippingNew.vue?vue&type=script&lang=js&"
export * from "./OrderShippingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a7f86c",
  null
  
)

export default component.exports